import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { useForm } from 'hooks';
import { FormGroup, required, SubmitButton } from 'components/common/Forms';
import { NotificationManager } from 'react-notifications';
import { Page} from 'components/common';
import { track, Errors } from 'react-redux-form';
import { find, update } from 'lodash';
import shortid from 'shortid';
import { Button } from 'reactstrap';

export const SLA = ({
  item,
  onBack,
  client,
  slaOnly = false,
  url = 'installers',
  readOnly,
  ...props
}) => {
  const [installers, setInstallers] = useState([]);
  const [installer, setInstaller] = useState(null);
  const [types, setTypes] = useState([]);

  const { 
    Form,
    value,
    store,
    Control,
    model,
    actions,
    dispatch,
    setValue,
    load,
    loaded,
    setRefreshToken
  } = useForm([]);

  const fetchInstallers = async () => {
    const installers = await client.get('installers').get('data');
    setInstallers(installers.map(i => ({
      ...i,
      'sla' : i.sla.map(p => ({'key':shortid(),...p})),
    })));
  };

  const fetchJobtypes = async () => {
    const jobtypes = await client.get('options?job_types').get('data');
    setTypes(jobtypes.job_types.concat([{'value':0,'text':'Any'}]));
  };

  useEffect(() => {
    fetchInstallers();
    fetchJobtypes();
  }, []);

  async function onSubmit(data) {
    try {
      data = Object.assign(installer, data);
      const replaceInstallText = {
        ...data, 
        'sla': data.sla.map(i => (
          {
            ...i,
            'installation_type': find(types, o =>
              o.text === i.installation_type_text
            ).value
          })
        )
      };

      const duplicate = ([h,...t],s) => (
         h === undefined ? false : (
          s.has(h.installation_type_text) ? true : ( 
            duplicate(t,s.add(h.installation_type_text))
          )
        )
      )
      
      if(duplicate(data.sla, new Set())) {
        throw "You have multiple SLA's for the same job type"
      }

      await client.put(url + "/" + installer.id, replaceInstallText);
      NotificationManager.success('Saved successfully');
      setTimeout(() => window.location.reload(),500);
    } catch(err) {
      NotificationManager.error(err);
    } finally {
      dispatch(actions.setPending('local', false));
    }
  }

  return (
    <Page title="SLAs" className="container">
      <Form
        onSubmit={onSubmit}
      >
        <FormGroup label="Installer" model=".installer">
          <Control.select disabled={readOnly} model=".installer" onChange={
            e => {
              const installer = find(installers, i => i.id == e.target.value);
              dispatch(actions.setInitial('local'));
              setInstaller(installer);
              if (installer && installer.sla) {
                dispatch(actions.change('local.sla',[]));
                installer.sla.map(e => dispatch(actions.push('local.sla', e)));
              } else if(typeof installer === 'undefined') {
                dispatch(actions.change('local.sla',[]));
              }
            }
          }>
            <option/>
            {installers.map(i => (
              <option key={i.id} value={i.id}>
                {i.name}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <br/>
        <table className="table">
          <thead>
            <tr>
              <th>{installer ? installer.name : ''}</th>
              <th> SLA</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            {store.getState().local.sla && store.getState().local.sla.map((p,i_p) => (
              <tr>
                <th>
                  <FormGroup model={track('local.sla[].installation_type_text',{'key':p.key})}>
                    <Control.select 
                      readOnly={readOnly}
                      model={track('local.sla[].installation_type_text',{'key':p.key})}
                      validators={{
                        required,
                      }}
                    >
                      {types.map(i => (
                        <option key={i.id} value={i.id}>
                          {i.text}
                        </option>
                      ))}
                    </Control.select>
                  </FormGroup>
                </th>
                <th>
                  <Control.input
                    readOnly={readOnly}
                    model={ track('local.sla[].sla',{'key':p.key}) }
                    type="number" 
                    style={{
                      width:60
                    }}
                    updateOn="change"
                    validators={{
                      required,
                    }}
                  />
                </th>
                <th>
                  <Button 
                    className='btn-danger'
                    onClick={() => {
                      dispatch(actions.remove('local.sla', i_p));
                    }}
                  > 
                    Delete
                  </Button>
                </th>
              </tr>
            ))}
          </tbody>
        </table>
        {installer ? 
        <div className='d-flex'>
          <div className='ml-auto'/>
          { store.getState().forms.local.$form.touched ? 
            <div className='mr-2 font-weight-bold text-danger'>
              Unsaved changes <div className='fa fa-exclamation-circle'/>
            </div> : ''
          }
          <Button 
            className='btn-info mr-2'
            onClick={e => dispatch(actions.push('local.sla', {
              'key':shortid(),
              'installation_type_text':'Any', 
              'installation_type' : 0,
              }))}
          >
            Add New
          </Button>
          <SubmitButton className='ml-2 mr-2 btn-success'>Save</SubmitButton>
        </div> : ''}
      </Form>
    </Page>
  )
};

export default SLA;



// WEBPACK FOOTER //
// ./src/pages/SLA.jsx